import { getCalculatedPrice } from 'pricing-pages-lib/utils/pricingUtils';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { getCurrentSkuIdForProduct } from 'pricing-pages-lib/utils/productsUtils';
import { CMS_HUB_PROFESSIONAL, CMS_HUB_STARTER, MARKETING_HUB_PROFESSIONAL, MARKETING_HUB_STARTER, OPERATIONS_HUB_PROFESSIONAL, OPERATIONS_HUB_STARTER, SALES_HUB_PROFESSIONAL, SALES_HUB_STARTER, SERVICE_HUB_PROFESSIONAL, SERVICE_HUB_STARTER } from 'self-service-api/constants/ApiNames';
import { PricingTier } from '../types';
export const getPricingLibState = state => {
  const pricingLibState = {
    productData: state.productData,
    promotions: state.promotions,
    gates: [],
    productInventory: {
      crmSuiteLevel: null,
      products: []
    },
    currencyCode: state.currencyCode,
    requiredOnboarding: state.requiredOnboarding
  };
  return pricingLibState;
};
export const getProductConfigsForCrmStarter = pricingLibState => {
  const starterProductConfigList = [CMS_HUB_STARTER, MARKETING_HUB_STARTER, OPERATIONS_HUB_STARTER, SALES_HUB_STARTER, SERVICE_HUB_STARTER].reduce((productConfigList, starterApiName) => {
    const starterSkuId = getCurrentSkuIdForProduct(pricingLibState, {
      apiName: starterApiName
    });
    const productConfigForApiName = createProductConfig({
      skuId: starterSkuId,
      quantity: 1
    });
    return [...productConfigList, productConfigForApiName];
  }, []);
  return starterProductConfigList;
};
export const getPriceForStarter = state => {
  const pricingLibState = getPricingLibState(state);
  const starterProductConfigList = getProductConfigsForCrmStarter(pricingLibState);
  const calculatedPriceForStarter = getCalculatedPrice(pricingLibState, {
    productConfigurations: starterProductConfigList
  });
  return calculatedPriceForStarter.monthly.fullPrice;
};
export const getPriceForProfessional = state => {
  const pricingLibState = getPricingLibState(state);
  const calculatedPriceList = [MARKETING_HUB_PROFESSIONAL, SALES_HUB_PROFESSIONAL, SERVICE_HUB_PROFESSIONAL, OPERATIONS_HUB_PROFESSIONAL, CMS_HUB_PROFESSIONAL].map(apiName => {
    const skuId = getCurrentSkuIdForProduct(pricingLibState, {
      apiName: apiName
    });
    const productConfig = createProductConfig({
      skuId: skuId,
      quantity: 1
    });
    const calculatedPrice = getCalculatedPrice(pricingLibState, {
      productConfigurations: [productConfig]
    });
    return calculatedPrice;
  });
  const monthlyPriceList = calculatedPriceList.map(calculatedPrice => calculatedPrice.monthly.fullPrice);
  return Math.min(...monthlyPriceList);
};
const PriceFunctionByTier = {
  [PricingTier.Free]: () => 0,
  [PricingTier.Starter]: getPriceForStarter,
  [PricingTier.Professional]: getPriceForProfessional
};
export const getPriceByTier = (state, tier) => {
  const priceFunction = PriceFunctionByTier[tier];
  const priceByTier = priceFunction(state);
  return priceByTier;
};